import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { isEmpty } from 'lodash';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { createAction } from '@inqool/uas-web-core/es/utils';

import { Input, InputField } from '@components/form';
import { InlineGrid, InlineGridField } from '@components/form';
import rolesCreateNewColumns from '@modules/roles-create/_rolesCreateNewColumns';
import { change } from 'redux-form';

const ActionBar = (
  { form, dispatch, setPermissionsAssigned, permissionsAssigned, setPermissionsAvailable, permissionsAvailable },
  grid
) => ({ checkedItems, ...gridProps }) => (
  <div>
    <Button
      label={grid === 'ASSIGNED' ? 'Odebrat' : 'Přiřadit'}
      primary={true}
      disabled={isEmpty(checkedItems)}
      onClick={() => {
        const newPermissionsAvailable =
          grid === 'ASSIGNED'
            ? [...permissionsAvailable, ...checkedItems]
            : permissionsAvailable.filter(el => !checkedItems.includes(el));
        const newPermissionsAssigned =
          grid === 'ASSIGNED'
            ? permissionsAssigned.filter(el => !checkedItems.includes(el))
            : [...permissionsAssigned, ...checkedItems];
        setPermissionsAssigned(newPermissionsAssigned);
        setPermissionsAvailable(newPermissionsAvailable);
        dispatch(change(form, 'permissionsAssigned', newPermissionsAssigned));
        dispatch(change(form, 'permissionsAvailable', newPermissionsAvailable));
        gridProps.dispatch(createAction('CHECK', []));
      }}
    />
  </div>
);

const View: React.SFC<any> = props => {
  return (
    <div>
      <Grid fluid={true}>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Název</h4>
              </Col>
              <Col md={12}>
                <InputField component={Input} name="name" />
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <h4>Popis</h4>
              </Col>
              <Col md={12}>
                <InputField component={Input} name="description" multiLine={true} />
              </Col>
            </Row>
          </Col>
          <Col md={12}>
            <Row className="without-min-width">
              <Col md={6}>
                <h4>Přiřazená oprávnění</h4>
                <InlineGridField
                  component={InlineGrid}
                  name="permissionsAssigned"
                  columns={rolesCreateNewColumns}
                  showCheckboxes={true}
                  deleting={false}
                  sort="label"
                  order="ASC"
                  version="2"
                  filtering={false}
                  adding={false}
                  ActionBar={ActionBar(props, 'ASSIGNED')}
                />
              </Col>
              <Col md={6}>
                <h4>Dostupná oprávnění</h4>
                <InlineGridField
                  component={InlineGrid}
                  name="permissionsAvailable"
                  columns={rolesCreateNewColumns}
                  showCheckboxes={true}
                  adding={false}
                  sort="label"
                  order="ASC"
                  version="1"
                  filtering={false}
                  ActionBar={ActionBar(props, 'AVAILABLE')}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Grid>
      <Divider />
    </div>
  );
};
export const RolesCreateFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/roles-create/RolesCreateFormBasic.tsx